import { Modal } from "react-bootstrap";

function InvoicesModal({ show, handleCloseModal, invoices, isClient }) {
  return (
    <Modal show={show} onHide={handleCloseModal}>
      <Modal.Header>
        <Modal.Title>Invoices</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <table className="table" style={{ margin: 0 }}>
          <thead>
            <tr>
              <th
                style={{ borderTop: "none", borderBottom: "1px solid #dee2e6" }}
              >
                Invoice Number
              </th>
              <th
                style={{
                  borderTop: "none",
                  borderBottom: "1px solid #dee2e6",
                  textAlign: "right",
                }}
              >
                Amount
              </th>
              {isClient && (
                <th
                  style={{
                    borderTop: "none",
                    borderBottom: "1px solid #dee2e6",
                    textAlign: "right",
                  }}
                >
                  Insured
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice, index) => {
              return (
                <tr key={index + "-" + invoice.invoiceNumber}>
                  <td>{invoice.invoiceNumber}</td>
                  <td style={{ textAlign: "right" }}>
                    {invoice.amount.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                  {isClient && (
                    <td style={{ textAlign: "right", paddingRight: "2rem" }}>
                      {invoice.insured ? (
                        <span style={{ color: "black", fontSize: "1.3rem" }}>
                          &#128504;
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleCloseModal}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default InvoicesModal;
